import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "p-container" };
const _hoisted_2 = { class: "d-flex flex-col w-100 mb-5" };
const _hoisted_3 = { class: "d-flex flex-row w-100" };
const _hoisted_4 = { class: "ml-auto d-flex flex-row gap-16px" };
const _hoisted_5 = {
    key: 0,
    class: "text-overview"
};
const _hoisted_6 = {
    key: 1,
    class: "text-overview"
};
const _hoisted_7 = {
    key: 0,
    class: "nav nav-tabs"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
    key: 0,
    class: "nav-item nav-title"
};
const _hoisted_10 = { class: "tab-content py-3" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { key: 1 };
const _hoisted_14 = {
    class: "d-flex gap-2",
    style: { "justify-content": "end !important" }
};
import ButtonComponent from '../components/Button.vue';
import EditCampaignView from './EditCampaign.vue';
import BaseModal from '@/components/BaseModal.vue';
import TableCampaignExpired from '../components/TableCampaignExpired.vue';
import 'vue-toast-notification/dist/theme-sugar.css';
import axios from 'axios';
import { ref, onMounted, onBeforeMount } from 'vue';
import version from '../../package.json';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
export default /*@__PURE__*/ _defineComponent({
    __name: 'routesView',
    props: {
        token: { type: String, },
        languageJson: { type: Array },
        baseUrl: { type: String },
        router: { type: Object },
        route: { type: Object },
    },
    setup(__props) {
        const props = __props;
        const status = ref('');
        const locked = ref(false);
        const isLoading = ref(false);
        const getError = ref(null);
        const activeItem = ref('');
        const userRole = ref("visitor");
        const isGroupsetModal = ref(false);
        const isError = ref(false);
        const isUserRoleError = ref(false);
        const tabs = ref([]);
        const editCampaignRef = ref(null);
        const showModalSblocca = ref(false);
        const countNewCampaigns = ref(1);
        // TODO: status computed per pulsante pubblica o meno.. deve ricalcolarsi ad ogni cambio tab
        const router = ref(props.router);
        const fetchUserInfo = async () => {
            isLoading.value = true;
            try {
                const response = await axios
                    .get(`${props.baseUrl}/v1/users/me`, {
                    headers: {
                        Authorization: `Bearer ${props.token}`,
                    },
                });
                getError.value = null;
                if (response.data.roles.admin) { // TODO: orrendo, da migliorare
                    userRole.value = "admin";
                    isUserRoleError.value = false;
                }
                else if (response.data.roles.curator) {
                    userRole.value = "curator";
                    isUserRoleError.value = false;
                }
                else {
                    userRole.value = "visitor";
                    isUserRoleError.value = true;
                }
            }
            catch (error) {
                getError.value = error;
                userRole.value = null;
                isUserRoleError.value = true;
            }
            finally {
                isLoading.value = false;
            }
        };
        const fetchGroupset = async () => {
            try {
                const response = await axios.get(`${props.baseUrl}/v1.1/private/groupsets`, {
                    headers: {
                        Authorization: `Bearer ${props.token}`,
                    },
                });
                getError.value = null;
                if (!response.data.results.length)
                    isGroupsetModal.value = true;
            }
            catch (error) {
                getError.value = error;
            }
        };
        const fetchData = async () => {
            isLoading.value = true;
            try {
                const response = await axios.get(`${props.baseUrl}/v1/private/campaigns`, {
                    params: {
                        orderBy: 'campaignStarts',
                        orderDir: 'desc'
                    },
                    headers: {
                        Authorization: `Bearer ${props.token}`,
                    },
                });
                if (response.data.results.length > 0) {
                    tabs.value = response.data.results.filter(campaign => campaign.expired === false);
                    activeItem.value = tabs.value[0].uuid;
                }
                console.log('Fetched campaigns:', response.data.results);
                getError.value = null;
            }
            catch (error) {
                getError.value = error;
            }
            finally {
                isLoading.value = false;
            }
        };
        const isActive = menuItem => {
            return activeItem.value === menuItem;
        };
        const setActive = menuItem => {
            activeItem.value = menuItem;
        };
        const createNewCampaign = () => {
            const newId = `new-campaign-${countNewCampaigns.value}`;
            tabs.value.push({ uuid: newId, name: `Nuova Campagna ${countNewCampaigns.value}` });
            countNewCampaigns.value += 1;
            setActive(newId);
        };
        const warningGoback = () => {
            router.value.go(-1);
        };
        const handleLocked = () => {
            if (locked.value)
                showModalSblocca.value = true;
            else
                locked.value = !locked.value;
        };
        onMounted(() => {
            console.log('Loading @laculturapremia v', version);
            fetchData();
            fetchUserInfo();
        });
        onBeforeMount(() => {
            fetchGroupset();
        });
        return (_ctx, _cache) => {
            const _component_widget_container_modal = _resolveComponent("widget-container-modal");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "text-title" }, "Campagne premi", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                (userRole.value === 'admin' && activeItem.value !== 'inevidence')
                                    ? (_openBlock(), _createBlock(ButtonComponent, {
                                        key: 0,
                                        text: locked.value ? 'Sblocca' : 'Blocca',
                                        type: "regular",
                                        class: "bg-white",
                                        isDisable: isLoading.value || getError.value,
                                        onHandleClick: handleLocked
                                    }, null, 8, ["text", "isDisable"]))
                                    : _createCommentVNode("", true),
                                (userRole.value === 'admin' && activeItem.value !== 'inevidence')
                                    ? (_openBlock(), _createBlock(ButtonComponent, {
                                        key: 1,
                                        text: "Salva",
                                        type: "regular",
                                        class: "bg-white",
                                        isDisable: isLoading.value || getError.value,
                                        onHandleClick: _cache[0] || (_cache[0] = () => editCampaignRef.value.handleEdit())
                                    }, null, 8, ["isDisable"]))
                                    : _createCommentVNode("", true),
                                (userRole.value === 'admin' && activeItem.value !== 'inevidence')
                                    ? (_openBlock(), _createBlock(ButtonComponent, {
                                        key: 2,
                                        class: _normalizeClass(status.value === 'PUBLISHED' ? 'bg-white' : 'bg-primary-custom'),
                                        text: "Pubblica campagna",
                                        type: "primary",
                                        isDisable: isLoading.value || getError.value || status.value === 'PUBLISHED',
                                        onHandleClick: _cache[1] || (_cache[1] = () => editCampaignRef.value.handleEdit('PUBLISHED'))
                                    }, null, 8, ["class", "isDisable"]))
                                    : _createCommentVNode("", true),
                                (userRole.value === 'admin')
                                    ? (_openBlock(), _createBlock(ButtonComponent, {
                                        key: 3,
                                        class: "bg-primary-custom",
                                        isDisable: isLoading.value || getError.value,
                                        text: "Nuova Campagna",
                                        type: "primary",
                                        onHandleClick: createNewCampaign
                                    }, null, 8, ["isDisable"]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]),
                    _createVNode(_component_widget_container_modal),
                    _createElementVNode("div", null, [
                        (isLoading.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                                _createVNode(_unref(Loading), {
                                    active: isLoading.value,
                                    "onUpdate:active": _cache[2] || (_cache[2] = ($event) => ((isLoading).value = $event)),
                                    "can-cancel": false,
                                    "is-full-page": true,
                                    color: "#2D489D",
                                    loader: "dots"
                                }, null, 8, ["active"])
                            ]))
                            : (getError.value || !(tabs.value.length > 0))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_6, "No data to display"))
                                : _createCommentVNode("", true)
                    ]),
                    (tabs.value.length > 0)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: tab.uuid,
                                    class: "nav-item nav-title"
                                }, [
                                    _createElementVNode("a", {
                                        class: _normalizeClass(["nav-link", { active: isActive(tab.uuid) }]),
                                        onClick: _withModifiers(($event) => (setActive(tab.uuid)), ["prevent"]),
                                        href: "#"
                                    }, _toDisplayString(tab.name), 11, _hoisted_8)
                                ]));
                            }), 128)),
                            (userRole.value === 'admin')
                                ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                                    _createElementVNode("a", {
                                        class: _normalizeClass(["nav-link", { active: isActive('inevidence') }]),
                                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (setActive('inevidence')), ["prevent"])),
                                        href: "#inevidence"
                                    }, "Archivio Campagne Scadute", 2)
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_10, [
                        (activeItem.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                (isLoading.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Loading..."))
                                    : (getError.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, "No data to display"))
                                        : _createCommentVNode("", true),
                                (activeItem.value !== 'inevidence')
                                    ? (_openBlock(), _createBlock(EditCampaignView, {
                                        key: activeItem.value,
                                        ref_key: "editCampaignRef",
                                        ref: editCampaignRef,
                                        baseUrl: props.baseUrl,
                                        router: router.value.value,
                                        languageJson: props.languageJson,
                                        campaignId: activeItem.value,
                                        locked: locked.value,
                                        onStatus: _cache[4] || (_cache[4] = (value) => status.value = value),
                                        onLocked: _cache[5] || (_cache[5] = (value) => locked.value = value)
                                    }, null, 8, ["baseUrl", "router", "languageJson", "campaignId", "locked"]))
                                    : _createCommentVNode("", true),
                                _withDirectives(_createElementVNode("div", null, [
                                    _createVNode(TableCampaignExpired, {
                                        baseUrl: props.baseUrl,
                                        token: props.token,
                                        userRole: userRole.value,
                                        router: router.value.value,
                                        languageJson: props.languageJson
                                    }, null, 8, ["baseUrl", "token", "userRole", "router", "languageJson"])
                                ], 512), [
                                    [_vShow, activeItem.value === 'inevidence']
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createVNode(BaseModal, {
                    isOpen: isUserRoleError.value || isGroupsetModal.value,
                    name: "warning-modal"
                }, {
                    header: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createElementVNode("h1", { class: "font-display-4" }, " Avvertimento! ", -1)
                        ]))]),
                    content: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createElementVNode("h5", null, "Per poter accedere alla sezione 'campagne' è necessario essere profilati come 'Responsabile del raggruppamento' o 'supporto al responsabile' nella piattaforma del Sistema museale nazionale.", -1)
                        ]))]),
                    footer: _withCtx(() => [
                        _createVNode(ButtonComponent, {
                            text: "Indietro",
                            type: "regular",
                            class: "bg-white",
                            isDisable: false,
                            onHandleClick: warningGoback
                        })
                    ]),
                    _: 1
                }, 8, ["isOpen"]),
                _createVNode(BaseModal, {
                    isOpen: isError.value && !isUserRoleError.value,
                    onModalClose: () => '',
                    name: "warning-modal"
                }, {
                    header: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("h3", null, " Avvertimento! ", -1)
                        ]))]),
                    content: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("h5", null, "Errore nel caricamento delle campagne.", -1)
                        ]))]),
                    footer: _withCtx(() => [
                        _createVNode(ButtonComponent, {
                            text: "Indietro",
                            type: "regular",
                            class: "bg-white",
                            isDisable: false,
                            onHandleClick: warningGoback
                        })
                    ]),
                    _: 1
                }, 8, ["isOpen"]),
                _createVNode(BaseModal, {
                    isOpen: showModalSblocca.value,
                    name: "warning-modal"
                }, {
                    header: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createElementVNode("h3", null, "Avvertimento!", -1)
                        ]))]),
                    content: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                            _createElementVNode("h5", null, "Sei sicuro di voler modificare una campagna in corso di promozione?", -1)
                        ]))]),
                    footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, [
                            _createVNode(ButtonComponent, {
                                text: "Conferma",
                                type: "primary",
                                class: "bg-primary-custom",
                                isDisable: false,
                                onHandleClick: _cache[6] || (_cache[6] = () => { locked.value = false; showModalSblocca.value = false; })
                            }),
                            _createVNode(ButtonComponent, {
                                text: "Annulla",
                                type: "regular",
                                class: "bg-white",
                                isDisable: false,
                                onHandleClick: _cache[7] || (_cache[7] = () => showModalSblocca.value = false)
                            })
                        ])
                    ]),
                    _: 1
                }, 8, ["isOpen"])
            ], 64));
        };
    }
});
